// Normalizes a value coming from/going to APIs that use comma-separated ID
// strings (e.g. MarketerID/MappingID: "136,114,101") into a plain number[].
// Accepts an already-normalized array, a single scalar, or null/undefined.
const toIdArray = (value) => {
  if (Array.isArray(value)) {
    return value.map(Number).filter((num) => !Number.isNaN(num));
  }
  if (value === null || value === undefined || value === "") {
    return [];
  }
  if (typeof value === "string") {
    return value
      .split(",")
      .map((item) => Number(item.trim()))
      .filter((num) => !Number.isNaN(num));
  }
  const num = Number(value);
  return Number.isNaN(num) ? [] : [num];
};

export default toIdArray;
